export const CELL_COLORS: Record<string, string> = {
  "#ef4444": "#ef4444", // red
  "#3b82f6": "#3b82f6", // blue
  "#eab308": "#eab308", // yellow
  "#22c55e": "#22c55e", // green
  "#a855f7": "#a855f7", // purple
  "#f97316": "#f97316", // orange
};

export const EMPTY_CELL_COLOR = "#1e293b";
export const GRID_LINE_COLOR = "#334155";
export const FOLD_LINE_COLOR = "#64748b";
export const FOLD_LINE_HOVER_COLOR = "#f59e0b";
export const FOLD_LINE_SELECTED_COLOR = "#f59e0b";
export const BACKGROUND_COLOR = "#0f172a";
export const CELL_BORDER_RADIUS = 4;

export function getCellDisplayColor(color: string | null): string {
  if (color === null) return EMPTY_CELL_COLOR;
  return color;
}
